import { cn } from "@/lib/utils"
import { ComponentProps, ReactNode } from "react"

export type RoundedButtonProps = ComponentProps<"button"> & {
  className?: string
  icon?: ReactNode
  children?: ReactNode
  onClick?: () => void
}

export default function RoundedButton({
  className,
  children,
  icon,
  onClick,
  ...props
}: RoundedButtonProps) {
  return (
    <button
      className={cn(
        `
          bg-blue shadow-drop-shadow flex h-7 w-fit
          items-center gap-1 rounded-full px-3 py-1.5
          text-xs font-semibold text-white
          hover:cursor-pointer
        `,
        className
      )}
      type="button"
      {...props}
      onClick={onClick}
    >
      {icon}
      {children}
    </button>
  )
}
